import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { updatePassword } from "sources/profile/user";
import { config, initialState } from "./config";

class ChangePassword extends PanelTemplate {
    setValue = ({ name, value }) => {
        const data = { ...this.state.data, [name]: value };
        const { newPassword, newPasswordRepeat, oldPassword } = data;
        let shouldUpdate = false;
        if (newPassword && newPasswordRepeat && oldPassword && newPassword === newPasswordRepeat) {
            shouldUpdate = true;
        }
        this.setState({ data, shouldUpdate });
    };

    update = () => {
        const { data, shouldUpdate } = this.state;
        if (shouldUpdate) {
            return updatePassword(data).then(() =>
                this.setState({ data: this.props.initialState, shouldUpdate: false }),
            );
        }
    };

    renderBody = () => {
        const { oldPassword, newPassword, newPasswordRepeat } = this.props.config;
        return (
            <div className="row">
                <div className="col-sm-4">
                    <h5>Смена пароля</h5>
                </div>
                <div className="col-sm-8">
                    {this.renderField(oldPassword)}
                    {this.renderField(newPassword)}
                    {this.renderField(newPasswordRepeat)}
                </div>
            </div>
        );
    };
}

const ConfiguredPanel = (props) => <ChangePassword {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
